'use strict';

/* Default values — set before any module reads them, updated by getWindowSizes() */
window.isMobile = window.isMobile || false;
window.isTablet = window.isTablet || false;
window.isTabletPortrait = window.isTabletPortrait || false;
window.isTabletLandscape = window.isTabletLandscape || false;
window.isDesktop = window.isDesktop || false;

/**
 * Get the window size and set the global variables
 * IMPORTANTE: Funzione estratta da common.js per ottimizzare gli import
 * Aggiorna body classes e variabili globali window.isMobile/isTablet/isDesktop
 */
const getWindowSizes = () => {
    if (window.matchMedia('(max-width: 767.98px)').matches) {
        $('body')
            .addClass('cc-mobile')
            .removeClass('cc-tablet')
            .removeClass('cc-desktop');
        window.isMobile = true;
        window.isTablet = false;
        window.isDesktop = false;
    } else if (window.matchMedia('(max-width: 1199.98px)').matches) {
        $('body')
            .removeClass('cc-mobile')
            .addClass('cc-tablet')
            .removeClass('cc-desktop');
        window.isMobile = false;
        window.isTablet = true;
        window.isDesktop = false;
    } else {
        $('body')
            .removeClass('cc-mobile')
            .removeClass('cc-tablet')
            .addClass('cc-desktop');
        window.isMobile = false;
        window.isTablet = false;
        window.isDesktop = true;
    }
};

module.exports = getWindowSizes;